<template>
  <button class="btn-red-wide" @click="begin">
    <span>Check your Eligibility</span>
    <svg width="13" height="23" viewBox="0 0 13 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.698418 0.984253C0.385238 1.29441 0.209302 1.71503 0.209302 2.1536C0.209302 2.59216 0.385238 3.01278 0.698418 3.32294L8.96765 11.51L0.698417 19.697C0.394112 20.009 0.22573 20.4268 0.229536 20.8604C0.233342 21.2941 0.409032 21.7089 0.718766 22.0156C1.0285 22.3222 1.4475 22.4962 1.88551 22.4999C2.32352 22.5037 2.74551 22.337 3.06058 22.0357L12.5109 12.6793C12.8241 12.3692 13 11.9486 13 11.51C13 11.0714 12.8241 10.6508 12.5109 10.3406L3.06058 0.984253C2.7473 0.674186 2.32247 0.5 1.8795 0.5C1.43653 0.499999 1.01169 0.674186 0.698418 0.984253Z" fill="white"/></svg>
  </button>
  <Transition>
    <div id="eligibility-modal" v-if="showModal" :class="{ show: showModal }">
      <div class="ec-modal">
        <RouterView/>
      </div>
    </div>
  </Transition>
</template>
<script>
// Animation maybe
// <RouterView v-slot="{ Component }">
//   <Transition name="fade">
//     <Component :is="Component" />
//   </Transition>
// </RouterView>

import { mapState } from 'vuex'

export default {
  computed: mapState({
    showModal: state => state.showModal
  }),
  created () {
    this.$store.dispatch('getData')
  },
  methods: {
    begin () {
      this.$store.commit('showModal')
    }
  }
}
</script>
<style lang="scss">
@import "./assets/scss/common";
@import "./assets/scss/mixins";

#eligibility-check-modal {
  position: relative;
  z-index: 10000000;
  margin-bottom: 2rem;

  &.container {
    max-width: 1200px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: 0;

    @include respond-above(lg) {
      padding: 0 50px;
    }
  }

  #ec-steps {
    height: 100%;
    min-height: 650px;

    @include respond-above(lg) {
      height: auto;
      min-height: 650px;
    }
  }
}

#eligibility-modal {
  z-index: 1000;
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: none;

  @include respond-above(lg) {
    justify-content: center;
    align-items: center;
  }

  &.show {
    display: flex;
  }

  .ec-modal {
    width: 100%;
    flex-grow: 1;
    display: block;
    height: 100%;

    @include respond-above(lg) {
      max-width: 1200px;
      height: auto;
      min-height: 650px;
    }
  }
}
</style>
